module.exports = __webpack_public_path__ + "static/img/bak_form.ec96fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bak_form.png
// module id = bcBN
// module chunks = 1